
import { Component, Vue } from "vue-property-decorator";

const ICON_ARCHIVE = "archive-outline";

@Component({
  components: {
    ArchivePopup: () => import("@/components/Popups/ArchivePopup.vue"),
  },
})
export default class ArchiveCandidate extends Vue {
  icon = ICON_ARCHIVE;

  archivePopup = false;

  openArchivePopup() {
    this.archivePopup = true;
  }

  closeArchivePopup() {
    this.archivePopup = false;
  }
}
